module.exports = __webpack_public_path__ + "img/paragraph.ef9d3380.png";